import { render, staticRenderFns } from "./TazminatAlacakForm.vue?vue&type=template&id=355b895a"
import script from "./TazminatAlacakForm.vue?vue&type=script&lang=ts"
export * from "./TazminatAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports